import { computed, defineComponent, onBeforeUnmount, onMounted, ref, set, useCssModule } from '@nuxtjs/composition-api';
import { useTask } from 'vue-concurrency';
import { PROJECTS } from '~/constants';
import { useA11y } from '~/composables';
import { useDuck } from '~/services';
/**
 * Duck service.
 */
const duck = useDuck();
export default defineComponent({
    name: 'BoxCard',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * Accessibility
         */
        const a11y = useA11y();
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        // Only if the article does not exist
        if (props.box.data && !props.box.data.article) {
            // Initializing the fields used in the template.
            set(props.box.data, 'article', {
                title: '',
                url_alias: '',
            });
        }
        const rootEl = ref();
        const intersectionObserver = ref();
        const isArticleExists = computed(() => typeof props.box.data?.article?.id === 'number');
        const label = computed(() => {
            const { rubrics = [], type } = props.box.data?.article || {};
            if (type) {
                return PROJECTS[props.box.data?.article?.type || 'partner'].title;
            }
            // return rubrics[0] || 'Партнерский материал'
            return rubrics[0] || 'Спецпроект';
        });
        const link = computed(() => {
            const { url_alias: path = '' } = props.box.data?.article || {};
            if (path && path.match(/(https?:)?\/\//g)) {
                return {
                    component: 'a',
                    attrs: {
                        href: path,
                        rel: 'noopener nofollow',
                        target: '_blank',
                    },
                };
            }
            return {
                component: 'NLink',
                attrs: {
                    to: '/' + path,
                },
            };
        });
        const withAdvertiser = computed(() => {
            const { ad, photo_present: withPhoto } = props.box.data?.article || {};
            const withAdvertiser = ad && ad.title;
            return props.box.type === 'partner' && (withPhoto || withAdvertiser);
        });
        /**
         * Fetch article task.
         */
        const fetchArticleTask = useTask(function* (signal) {
            signal.addEventListener('abort', () => duck.abortRequest('getPubArticleId'));
            if (!props.box.data?.id) {
                return console.error('There is no id in box.data');
            }
            try {
                const { data: article } = yield duck.pub.getPubArticleId(props.box.data.id);
                set(props.box.data, 'article', article);
            }
            catch (error) {
                console.error(error);
            }
        });
        onBeforeUnmount(() => {
            intersectionObserver.value?.disconnect();
        });
        onMounted(() => {
            // If the article exist do nothing
            if (isArticleExists.value) {
                return;
            }
            intersectionObserver.value = new IntersectionObserver(([entry], observer) => {
                if (entry && entry.isIntersecting) {
                    fetchArticleTask.perform();
                    observer?.unobserve(entry.target);
                }
            });
            intersectionObserver.value?.observe(rootEl.value);
        });
        return {
            a11y,
            css,
            fetchArticleTask,
            isArticleExists,
            label,
            link,
            rootEl,
            withAdvertiser,
        };
    },
});
